import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "@/i18n";
import { TripProvider } from "@/TripContext";
import { FavoritesProvider } from "@/FavoritesContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import DestinationsGallery from "@/components/DestinationsGallery";
import DestinationDetail from "@/components/DestinationDetail";
import TripPlanner from "@/components/TripPlanner";
import AiAssistantChat from "@/components/AiAssistantChat";
import PricesHub from "@/components/PricesHub";
import FavoritesPage from "@/components/FavoritesPage";
import SharedTripPage from "@/components/SharedTripPage";
import PromotePage from "@/components/PromotePage";
import { PrivacyPage, AboutPage, ContactPage } from "@/components/PolicyPages";
import { BlogIndex, BlogPost } from "@/components/BlogPages";
import FeaturedDeals from "@/components/FeaturedDeals";
import AdSlot from "@/components/AdSlot";
import { trackIncomingReferral } from "@/referral";

function Home() {
  return (
    <>
      <HeroSection />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 mt-4">
        <AdSlot slotId={process.env.REACT_APP_ADSENSE_SLOT_HOME_BANNER} layout="banner" />
      </div>
      <FeaturedDeals />
      <DestinationsGallery />
    </>
  );
}

function ReferralTracker() {
  useEffect(() => { trackIncomingReferral(); }, []);
  return null;
}

function App() {
  return (
    <I18nProvider>
      <FavoritesProvider>
        <TripProvider>
          <BrowserRouter>
            <ReferralTracker />
            <div className="App min-h-screen flex flex-col">
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/destination/:id" element={<DestinationDetail />} />
                  <Route path="/planner" element={<TripPlanner />} />
                  <Route path="/assistant" element={<AiAssistantChat />} />
                  <Route path="/prices" element={<PricesHub />} />
                  <Route path="/favorites" element={<FavoritesPage />} />
                  <Route path="/trip/:id" element={<SharedTripPage />} />
                  <Route path="/promote" element={<PromotePage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/blog" element={<BlogIndex />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                </Routes>
              </main>
              <Footer />
              <Toaster position="top-center" richColors />
            </div>
          </BrowserRouter>
        </TripProvider>
      </FavoritesProvider>
    </I18nProvider>
  );
}

export default App;
